import cn from 'classnames';
import * as PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { ReactComponent as MenuIndicator } from './images/menu-indicator.svg';
import styles from './Spoiler.module.scss';

class Spoiler extends PureComponent {
  spoiler = React.createRef();

  state = {
    show: this.props.defaultShow,
  };

  componentDidUpdate(prevProps) {
    (async () => {
      const { hasErrors, updateOnRefChange } = this.props;
      if (hasErrors && prevProps.updateOnRefChange !== updateOnRefChange) {
        await this.openSpoiler();
      }
    })();
  }

  getThemeClassName() {
    const { theme } = this.props;
    const themeClasses = {
      white: styles.white,
      blue: styles.blue,
      red: styles.red,
    };

    return themeClasses[theme] ? themeClasses[theme] : themeClasses.white;
  }

  showContent = async () => {
    return await this.openSpoiler();
  };

  closeContent = () => {
    return this.closeSpoiler();
  };

  toggleShow = () => {
    const { onShow } = this.props;
    const { show } = this.state;

    this.setState({ show: !show }, () => {
      if (onShow) {
        onShow(show);
      }
    });
  };

  scrollIntoView() {
    if (!this.spoiler.current) {
      return;
    }
    this.spoiler.current.scrollIntoView();
  }

  async openSpoiler() {
    const { onShow } = this.props;
    const { show } = this.state;

    return new Promise((resolve) => {
      this.setState({ show: true }, () => {
        if (onShow) {
          onShow(show);
        }
        resolve();
      });
    });
  }

  closeSpoiler() {
    this.setState({ show: false });
  }

  renderSpoilerIndicator() {
    const { btnPosition, indicatorClassName } = this.props;
    return (
      <div
        className={cn([
          styles.menuIndicator,
          indicatorClassName,
          {
            [styles.left]: btnPosition === 'left',
            [styles.right]: btnPosition === 'right',
          },
        ])}
      >
        <MenuIndicator />
        <span className="replace_text replace_text__first">Показать</span>
        <span className="replace_text replace_text__second">Скрыть</span>
      </div>
    );
  }

  render() {
    const {
      title,
      children,
      className,
      btnPosition,
      headerClassName,
      contentClassName,
      unmountOnHide,
    } = this.props;
    const { show } = this.state;

    return (
      <div
        ref={this.spoiler}
        className={cn([
          styles.spoiler,
          this.getThemeClassName(),
          {
            [styles.spoilerOpened]: show,
            [className]: className,
          },
        ])}
      >
        <div className={cn([styles.spoilerItemHeader, headerClassName])} onClick={this.toggleShow}>
          {btnPosition === 'left' && this.renderSpoilerIndicator()}
          <div className={styles.title}>{title}</div>
          {btnPosition === 'right' && this.renderSpoilerIndicator()}
        </div>
        {(!unmountOnHide || (unmountOnHide && show)) && (
          <div className={`${styles.content} ${contentClassName}`}>{children}</div>
        )}
      </div>
    );
  }
}

Spoiler.defaultProps = {
  btnPosition: 'left',
  theme: 'white',
  headerClassName: '',
  contentClassName: '',
  indicatorClassName: '',
};

Spoiler.propTypes = {
  onShow: PropTypes.func,
  defaultShow: PropTypes.bool,
  title: PropTypes.any,
  children: PropTypes.any,
  className: PropTypes.string,
  hasErrors: PropTypes.bool,
  updateOnRefChange: PropTypes.object,
  theme: PropTypes.oneOf(['white', 'blue', 'red']),
  btnPosition: PropTypes.oneOf(['left', 'right']),
  headerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  unmountOnHide: PropTypes.bool,
  indicatorClassName: PropTypes.string,
};

export default Spoiler;
